import type {ModalStorage} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

export const useModalData = (modalId: string): ModalStorage => {
  return useAppSelector((state) => {
    return state.modals.modalsHashmap[modalId];
  });
};
